module.exports = __webpack_public_path__ + "assets/img/thumb-fallback2.4a96ca8c.jpg";